const RelatedList = require('module/user/related_list')
const Product = require('module/user/product')

const order = [
    'plan',
    'credit',
    'domain',
]

const ProductList = RelatedList.extend({

    model: Product,

    // ensure that plan is shown first, then credit, then domain
    comparator(model_a, model_b) {
        const a = order.indexOf(model_a.get('type'))
        const b = order.indexOf(model_b.get('type'))
        if (a < b) return -1
        if (a > b) return 1
        return 0
    },

})

module.exports = ProductList
